import { render } from "./ImpulseCodeOverlay.vue?vue&type=template&id=dbacd770&scoped=true"
import script from "./ImpulseCodeOverlay.vue?vue&type=script&lang=js"
export * from "./ImpulseCodeOverlay.vue?vue&type=script&lang=js"

import "./ImpulseCodeOverlay.vue?vue&type=style&index=0&id=dbacd770&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbacd770"]])

export default __exports__